import {LANGUAGE} from '@/common/utils/constants';

export const PROJECT_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		document: "document",
		short: "Short",
		full: "Full",
		copiedProject: "The project has been copied to the clipboard",
		what: "What seems to be the problem?",
		newBusiness: "NEW BUSINESS",
		confidentialName: "Client’s name is confidential",
		companyInternal: "For internal purposes only. Do not share client information outside of the organization.",
		allIndustries: "All Industries",
		noTitle: 'The title will be filled by the CMT',
		contentTypes: {
			clientContext: "Client context",
			akkodisChallenge: "Akkodis challenges",
			solution: "Solution",
			clientResult: "Client results",
			akkodisResult: "Akkodis results"
		},
		aside: {
			businessManager: "Business manager",
			publishedBy: "Published by",
			validatedIn: "Language validation:",
			deliveryManager: "Delivery manager",
			certificates: "Certifications",
			tools: "Tools",
			practices: "Tech practices",
			services: "Type of Business",
			references: "additional links/References",
			clientLocation: "Client’s locations covered",
			deliveryLocation: "Project delivery locations",
			relatedOffers: "Related Offers",
			industries: "Industries",
			publishedDate: 'Publication date',
			showLess: 'Show less',
			more: 'more',
			views: 'Views'
		},
		toolTips: {
			copy: "Copy link",
			download: "Download",
			report: "Report a problem"
		},
		moreProjects: {
			validatedIn: "Validated in:",
			from: "from",
			title: "More Projects",
			viewMore: "View more projects",
			noAvailableProjects: "There aren't any more projects from this industry."
		},
		views: 'Views',
		saved: "Saved",
		featured: 'featured',
		selected: 'Selected'
	},
	[LANGUAGE.de.short]: {
		document: "dokumentieren",
		short: "Kurz",
		full: "Voll",
		copiedProject: "Das Projekt wurde in die Zwischenablage kopiert",
		what: "Was scheint das Problem zu sein?",
		newBusiness: "NEUES GESCHÄFT",
		confidentialName: "Der Name des Kunden ist vertraulich",
		companyInternal: "Nur für interne Zwecke. Geben Sie keine Kundeninformationen außerhalb der Organisation weiter.",
		allIndustries: "Alle Branchen",
		noTitle: 'Der Titel wird von der CMT besetzt',
		contentTypes: {
			clientContext: "Client-Kontext",
			akkodisChallenge: "Akkodis-Herausforderungen",
			solution: "Lösung",
			clientResult: "Kundenergebnisse",
			akkodisResult: "Akkodis-Ergebnisse"
		},
		aside: {
			businessManager: "Geschäftsführer",
			publishedBy: "Herausgegeben von",
			validatedIn: "Sprachvalidierung:",
			deliveryManager: "Liefermanager",
			certificates: "Zertifizierungen",
			tools: "Werkzeug",
			practices: "Tech-Praktiken",
			services: "Geschäftsart",
			references: "weiterführende Links/Referenzen",
			clientLocation: "Kundenstandorte abgedeckt",
			deliveryLocation: "Lieferorte für Projekte",
			relatedOffers: "Angebote zur Tour",
			industries: "Branchen",
			publishedDate: 'Veröffentlichungsdatum',
			showLess: 'Weniger anzeigen',
			more: 'mehr',
			views: 'Ansichten'
		},
		toolTips: {
			copy: "Link kopieren",
			download: "Download",
			report: "Ein Problem melden"
		},
		moreProjects: {
			validatedIn: "Validiert in:",
			from: "aus",
			title: "Weitere Projekte",
			viewMore: "Weitere Projekte anzeigen",
			noAvailableProjects: "Es gibt keine weiteren Projekte aus dieser Branche."
		},
		views: 'Ansichten',
		saved: "Gespeichert",
		featured: 'EMPFOHLEN',
		selected: 'Gewählt'
	},
	[LANGUAGE.fr.short]: {
		document: "document",
		short: "Court",
		full: "Complet",
		copiedProject: "Le projet a été copié dans le presse-papiers",
		what: "Quel semble être le problème?",
		newBusiness: "NOUVELLE ENTREPRISE",
		confidentialName: "Le nom du client est confidentiel",
		companyInternal: "À des fins internes uniquement. Ne partagez pas les informations des clients en dehors de l'organisation.",
		allIndustries: "Tous les secteurs",
		noTitle: 'Le titre sera rempli par le CMT',
		contentTypes: {
			clientContext: "Contexte client",
			akkodisChallenge: "Défis d'Akkodis",
			solution: "La solution",
			clientResult: "Résultats clients",
			akkodisResult: "Akkodis résultats"
		},
		aside: {
			businessManager: "Responsable commercial",
			publishedBy: "Publié par",
			validatedIn: "Validation linguistique:",
			deliveryManager: "Responsable du projet",
			certificates: "Certifications",
			tools: "Outils",
			practices: "Pratiques techniques",
			services: "Type d'activité",
			references: "liens/références supplémentaires",
			clientLocation: "Emplacements du client couverts",
			deliveryLocation: "Lieux de livraison du projet",
			relatedOffers: "Offres connexes",
			industries: "industries",
			publishedDate: 'Date de publication',
			showLess: 'Afficher moins',
			more: 'encore de',
			views: 'Vues'
		},
		toolTips: {
			copy: "Copier le lien",
			download: "Télécharger",
			report: "Signaler un problème"
		},
		moreProjects: {
			validatedIn: "Validé en:",
			from: "de",
			title: "Plus de projets",
			viewMore: "Voir plus de projets",
			noAvailableProjects: "Il n'y a plus de projets de cette industrie."
		},
		views: 'Vues',
		saved: "Enregistré",
		featured: 'EN VEDETTE',
		selected: 'Choisi'
	},
	[LANGUAGE.it.short]: {
		document: "documento",
		short: "Corto",
		full: "Completo",
		copiedProject: "Il progetto è stato copiato negli appunti",
		what: "Quello che sembra essere il problema?",
		newBusiness: "NUOVO BUSINESS",
		confidentialName: "Il nome del cliente è riservato",
		companyInternal: "Solo per scopi interni. Non condividere le informazioni sui clienti al di fuori dell'organizzazione.",
		allIndustries: "Tutti i settori",
		noTitle: 'Il titolo sarà compilato dal CMT',
		contentTypes: {
			clientContext: "Contesto del cliente",
			akkodisChallenge: "Sfide di Akkodis",
			solution: "Soluzione",
			clientResult: "Risultati del cliente",
			akkodisResult: "Risultati di Akkodis"
		},
		aside: {
			businessManager: "Responsabile aziendale",
			publishedBy: "Pubblicato da",
			validatedIn: "Convalida della lingua:",
			deliveryManager: "Direttore di consegna",
			certificates: "Certificazioni",
			tools: "Strumenti",
			practices: "Pratiche tecniche",
			services: "Tipologia di attività",
			references: "link/riferimenti aggiuntivi",
			clientLocation: "Località del cliente coperte",
			deliveryLocation: "Luoghi di consegna del progetto",
			relatedOffers: "Offerte correlate",
			industries: "industrie",
			publishedDate: 'Data di pubblicazione',
			showLess: 'Mostra meno',
			more: 'di più',
			views: 'Visualizzazioni'
		},
		toolTips: {
			copy: "Copia link",
			download: "Scarica",
			report: "Segnala un problema"
		},
		moreProjects: {
			validatedIn: "Convalidato in:",
			from: "da",
			title: "Altri progetti",
			viewMore: "Visualizza più progetti",
			noAvailableProjects: "Non ci sono più progetti da questo settore."
		},
		views: 'Visualizzazioni',
		saved: "Salvato",
		featured: 'In evidenza',
		selected: 'Selezionato'
	},
	[LANGUAGE.ja.short]: {
		document: "資料",
		short: "ショート",
		full: "フル",
		copiedProject: "プロジェクトがクリップボードにコピーされました",
		what: "問題に見えるのは？",
		newBusiness: "新しいビジネス",
		confidentialName: "クライアントの名前は非公開です",
		companyInternal: "内部目的のみ。 顧客情報を組織外と共有しないでください。",
		allIndustries: "すべての産業",
		noTitle: 'タイトルはCMTが記入します',
		contentTypes: {
			clientContext: "クライアントのコンテキスト",
			akkodisChallenge: "アッコディスの挑戦",
			solution: "解決",
			clientResult: "クライアントの結果",
			akkodisResult: "アッコディスの結果"
		},
		aside: {
			businessManager: "経営者",
			publishedBy: "発行者",
			validatedIn: "言語の検証:",
			deliveryManager: "配達マネージャー",
			certificates: "認証",
			tools: "ツール",
			practices: "技術の実践",
			services: "事業の種類",
			references: "追加のリンク/参考文献",
			clientLocation: "対象となるクライアントの場所",
			deliveryLocation: "プロジェクトの配信場所",
			relatedOffers: "関連オファー",
			industries: "産業",
			publishedDate: '発行日',
			showLess: '表示を減らす',
			more: 'もっと',
			views: 'ビュー'
		},
		toolTips: {
			copy: "リンクをコピーする",
			download: "ダウンロード",
			report: "問題を報告します"
		},
		moreProjects: {
			validatedIn: "検証済み:",
			from: "から",
			title: "その他のプロジェクト",
			viewMore: "他のプロジェクトを見る",
			noAvailableProjects: "この業界からのプロジェクトはこれ以上ありません。"
		},
		views: 'ビュー',
		saved: "保存",
		featured: '特集',
		selected: '選択済み'
	},
	[LANGUAGE.es.short]: {
		document: "documento",
		short: "Corto",
		full: "Completo",
		copiedProject: "El proyecto ha sido copiado al portapapeles",
		what: "¿Cuál parece ser el problema?",
		newBusiness: "NUEVO NEGOCIO",
		confidentialName: "El nombre del cliente es confidencial",
		companyInternal: "Solo para fines internos. No comparta la información del cliente fuera de la organización.",
		allIndustries: "Todas las industrias",
		noTitle: 'El título será completado por el CMT',
		contentTypes: {
			clientContext: "Contexto del cliente",
			akkodisChallenge: "Desafíos de Akkodis",
			solution: "Solución",
			clientResult: "Resultados del cliente",
			akkodisResult: "Resultados de Akkodis"
		},
		aside: {
			businessManager: "Gerente de negocios",
			publishedBy: "Publicado por",
			validatedIn: "Validación de idioma:",
			deliveryManager: "Gerente de entrega",
			certificates: "Certificaciones",
			tools: "Herramientas",
			practices: "Prácticas técnicas",
			services: "Tipo de negocio",
			references: "enlaces/referencias adicionales",
			clientLocation: "Ubicaciones del cliente cubiertas",
			deliveryLocation: "Ubicaciones de entrega del proyecto",
			relatedOffers: "Ofertas relacionadas",
			industries: "industrias",
			publishedDate: 'Fecha de publicación',
			showLess: 'Mostrar menos',
			more: 'más',
			views: 'Vistas'
		},
		toolTips: {
			copy: "Copiar enlace",
			download: "Descargar",
			report: "Reportar un problema"
		},
		moreProjects: {
			validatedIn: "Validado en:",
			from: "de",
			title: "Más proyectos",
			viewMore: "Ver más proyectos",
			noAvailableProjects: "No hay más proyectos de esta industria."
		},
		views: 'Vistas',
		saved: "Guardado",
		featured: 'Destacado',
		selected: 'Seleccionado'
	}
}
